export type SupportedUiLang = 'ru' | 'en';

const DEFAULT_AVAILABLE: SupportedUiLang[] = ['ru', 'en'];

/**
 * REACT_APP_AVAILABLE_LANGS строка из env (по умолчанию ru + en).
 * Для English-only брендов: REACT_APP_AVAILABLE_LANGS: 'en'
 */
export const getAvailableLangs = (): SupportedUiLang[] => {
    if (process.env.REACT_APP_AVAILABLE_LANGS?.trim() === 'en') {
        return ['en'];
    }

    return [...DEFAULT_AVAILABLE];
};
